<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("ratecard") }}
      </div>
      <router-link class="btn-blue" to="rateCard"
        >{{ $t("ratecard") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material disable-edit">
              <input
                placeholder="."
                v-model="selectedCinema"
                disabled
                type="text"
                name="selectedCinema"
                id="selectedCinema"
              />
              <label class="">{{ $tc("cinema", 1) }} {{ $t("name") }}</label>
              <!-- <label :disabled="isRoleID">{{ selectedCinema }}</label> -->
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material disable-edit">
              <!-- <input v-model="ratecard.rc_name" type="text" required="required" /> -->
              <!-- <label>{{ ratecard.rc_name }}</label> -->
              <input
                placeholder="."
                v-model="ratecard.rc_name"
                type="text"
                name="rc_name"
                id="rc_name"
              />
              <label>{{ $t("ratedCardName") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div
              v-if="cinemaChargesList.length > 0"
              class="input-material disable-edit"
            >
              <input
                placeholder="."
                v-model="cinemaChargesList[0].pas_charge_setting_name"
                disabled
                type="text"
                name="pas_charge_setting_name"
                id="pas_charge_setting_name"
              />
              <label
                >{{ $tc("charge", 1) }} {{ $tc("setting", 1) }}
                {{ $t("name") }}</label
              >
              <!-- <input disabled v-model="ratecard.rc_name" type="text" required="required" /> -->
              <!-- <label>{{ cinemaChargesList[0].pas_charge_setting_name }}</label> -->
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material disable-edit">
              <input
                placeholder="."
                v-model="ratecard.rc_amount"
                disabled
                type="text"
                name="rc_amount"
                id="rc_amount"
              />
              <label>Total {{ $t("amount") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material disable-edit">
              <input
                placeholder="."
                v-model="selectedItem"
                disabled
                type="text"
                name="selectedItem"
                id="selectedItem"
              />
              <label>{{ $t("fnbitem") }} {{ $t("name") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material disable-edit">
              <input
                placeholder="."
                v-model="ratecard.internet_handling_fee"
                disabled
                type="number"
                name="internet_handling_fee"
                id="internet_handling_fee"
              />
              <label>{{ $t("internetHandlingFees") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("inclusivoftax") }}</label>
            <b-form-checkbox
              disabled
              unchecked-value="N"
              value="Y"
              v-model="ratecard.rc_is_active_inclusivtax"
              name="check-button"
              @change="OnSwitchHandler($event)"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3"
              >{{ $t("item") }} {{ $t("compulosry") }}</label
            >
            <b-form-checkbox
              disabled
              v-model="ratecard.item_is_compulsory"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div> -->

        <div class="col-md-12">
          <!-- <div class="font-weight-bold mb-2">
            {{ $t("add") }} {{ $tc("charge", 2) }}
          </div> -->

          <div v-if="chargeList.length > 0">
            <span class="font-weight-bold text-blue fs-16">Tax Structure</span>
            <table class="swc-report-table mb-3" border="1">
              <thead>
                <tr>
                  <th>{{ $t("Tax Name") }}</th>
                  <th>{{ $t("Tax Value") }}</th>
                  <th class="text-right">{{ $t("Total Tax") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(cinemaCharge, cinemaChargesIndex) in chargeList"
                  :key="cinemaChargesIndex"
                >
                  <td>{{ cinemaCharge.ct_name }}</td>
                  <td>
                    {{ cinemaCharge.pas_charge_value
                    }}{{ cinemaCharge.pas_is_percentage == "Y" ? "%" : "" }}
                  </td>
                  <td class="text-right">
                    {{ currencyData.curr_code }}&nbsp;{{
                      cinemaCharge.pas_is_rebate === "Y"
                        ? "-" + cinemaCharge.cinemacharges.toFixed(this.MIN_FRACTION_DIGITS)
                        : cinemaCharge.cinemacharges.toFixed(this.MIN_FRACTION_DIGITS)
                    }}
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <span class="font-weight-bold text-center"
                      >Applicable Tickets Tax</span
                    >
                  </td>
                  <td colspan="1" class="text-right font-weight-bold">
                    {{ currencyData.curr_code }}&nbsp;{{
                      parseFloat(
                        ratecard.rc_total_amount - ratecard.rc_net_amount
                      ).toFixed(3)
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row totalCalculations">
            <div class="col-md-12">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">Net Amount:</span>
                <span class="col-6 text-right"
                  >{{ currencyData.curr_code }}
                  {{ ratecard.rc_net_amount.toFixed(3) }}</span
                >
              </div>
            </div>
            <div class="col-md-12">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">Tax (Tickets):</span>
                <span class="col-6 text-right"
                  >{{ currencyData.curr_code }}&nbsp;{{
                    parseFloat(
                      ratecard.rc_total_amount - ratecard.rc_net_amount
                    ).toFixed(3)
                  }}</span
                >
              </div>
            </div>

            <div class="col-md-12 mb-2" v-if="selectedItemObj">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">Ticket Total:</span>
                <span class="col-6 text-right font-weight-bold"
                  >{{ currencyData.curr_code }}
                  {{ ratecard.rc_total_amount.toFixed(this.MIN_FRACTION_DIGITS) }}</span
                >
              </div>
            </div>

            <div class="col-md-12" v-if="selectedItemObj">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">F&B Item Net Amount:</span>
                <span class="col-6 text-right"
                  >{{ currencyData.curr_code }}
                  {{
                    selectedItemObj.fp_amount &&
                    parseInt(selectedItemObj.fp_amount)
                      ? selectedItemObj.fp_amount.toFixed(this.MIN_FRACTION_DIGITS)
                      : "0.00"
                  }}</span
                >
              </div>
            </div>
            <div class="col-md-12" v-if="selectedItemObj">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">F&B Taxes:</span>
                <span class="col-6 text-right"
                  >{{ currencyData.curr_code }}
                  {{
                    selectedItemObj.fp_total_amount !== null &&
                    selectedItemObj.fp_amount !== null &&
                    parseInt(selectedItemObj.fp_total_amount) &&
                    parseInt(selectedItemObj.fp_amount)
                      ? (
                          selectedItemObj.fp_total_amount -
                          selectedItemObj.fp_amount
                        ).toFixed(this.MIN_FRACTION_DIGITS)
                      : "0.00"
                  }}</span
                >
              </div>
            </div>
            <div class="col-md-12 mb-2" v-if="selectedItemObj">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">F&B Total:</span>
                <span class="col-6 text-right font-weight-bold"
                  >{{ currencyData.curr_code }}
                  {{
                    selectedItemObj.fp_total_amount !== null &&
                    parseInt(selectedItemObj.fp_total_amount)
                      ? selectedItemObj.fp_total_amount.toFixed(this.MIN_FRACTION_DIGITS)
                      : "0.00"
                  }}</span
                >
              </div>
            </div>
            <div class="col-md-12">
              <div class="row w-25 float-right totalborder">
                <span class="col-6 font-weight-bold fs-16">Gross Total:</span>
                <span class="col-6 text-right font-weight-bold"
                  >{{ currencyData.curr_code }}
                  {{
                    (
                      ratecard.rc_total_amount +
                      (selectedItemObj &&
                      selectedItemObj.fp_total_amount &&
                      parseInt(selectedItemObj.fp_total_amount)
                        ? selectedItemObj.fp_total_amount
                        : 0)
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  }}</span
                >
              </div>
            </div>
          </div>
          <div
            v-if="false"
            class="col-12"
            v-for="(cinemaCharge, cinemaChargesIndex) in chargeList"
            :key="cinemaChargesIndex"
          >
            <div class="row">
              <!-- IMAGE DIMENSION -->
              <div class="col-md-5 mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-material disable-edit">
                    <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                    <label>{{ cinemaCharge.ct_name }}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-7">
                <div class="row">
                  <div class="col-md-5">
                    <div
                      class="
                        d-flex
                        justify-content-center
                        align-items-center
                        p-3
                      "
                    >
                      <label
                        >{{ cinemaCharge.pas_charge_value
                        }}{{
                          cinemaCharge.pas_is_percentage == "Y" ? "%" : ""
                        }}</label
                      >
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div
                      class="
                        d-flex
                        justify-content-center
                        align-items-center
                        p-3
                      "
                    >
                      <label>{{
                        cinemaCharge.pas_is_rebate === "Y"
                          ? "-" + cinemaCharge.cinemacharges.toFixed(this.MIN_FRACTION_DIGITS)
                          : cinemaCharge.cinemacharges.toFixed(this.MIN_FRACTION_DIGITS)
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center pt-3">
            <label>{{ $t("active") }}&nbsp;</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="ratecard.rc_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <!-- <button @click.prevent.stop="resetForm()" class="btn-black">{{ $t('reset') }}</button> -->
          <b-button class="btn-outline-grey" variant="default" to="rateCard">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      //Saif
      currencyData: [],
      cinemaChargesList: [],
      cinemaList: [],
      fnbItems: [],
      selectedCinema: "",
      selectedItem: "",
      selectedItemObj: null,
      ratecard: {
        rc_id: null,
        cinema_id: null,
        rc_name: "",
        rc_amount: 0,
        rc_total_amount: 0,
        currency_id: null,
        rc_is_active_inclusivtax: "Y",
        item_id: null,
        item_is_compulsory: false,
        rc_is_active: "N",
        rc_net_amount: 0,
      },
      // Saif
      imageSettingList: [],
      imageSettingList1: [],
      status: true,
      recipeList: [
        {
          name: "Popcorn",
          qty: "50 gms",
        },
        {
          name: "Salt",
          qty: "2 gms",
        },
        {
          name: "Oil",
          qty: "2 gms",
        },
      ],

      grossTotal: 0,
      chargeList: [],
      netTotal: 0,
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }

    const { id } = this.$route.query;
    if (id) {
      this.getEditRatecardList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.getCurrencyCode();
  },
  methods: {
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    // Saif
    resetForm: function () {
      this.selectedCinema = "";
      this.ratecard = {
        rc_id: null,
        cinema_id: null,
        rc_name: "",
        rc_amount: 0,
        rc_total_amount: 0,
        currency_id: null,
        rc_is_active_inclusivtax: "Y",
      };
      this.cinemaChargesList = [];
    },
    // onDropdownChange: function(event, item) {
    //   this.selectedCinema = item.cine_name;
    //   this.ratecard.cinema_id = item.cine_id;
    //   this.getCinemaCharges(item.cine_id);
    // },
    // OnSwitchHandler: function(event) {
    //   this.ratecard.rc_is_active_inclusivtax = event;
    //   this.cinemaChargesCalculation();
    // },
    onChangeRatecardAmount: function (event) {
      this.cinemaChargesCalculation();
    },
    cinemaChargesCalculation: function () {
      this.ratecard.rc_net_amount = parseFloat(this.ratecard.rc_amount);
      this.ratecard.rc_total_amount = parseFloat(this.ratecard.rc_total_amount);

      this.cinemaChargesList.map((x) => {
        x["cinemacharges"] = 0;
        if (this.ratecard.rc_is_active_inclusivtax === "N") {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              (parseFloat(this.ratecard.rc_amount) *
                parseFloat(x.pas_charge_value)) /
              100;
          }
          this.calculateNetAmount(x, "Plus");
          // this.ratecard.rc_net_amount += parseFloat(x.cinemacharges);
        } else if (this.ratecard.rc_is_active_inclusivtax === "Y") {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              ((parseFloat(this.ratecard.rc_amount) /
                this.calculatePercentageCharge(x)) *
                parseFloat(x.pas_charge_value)) /
              100;
          }
          this.calculateNetAmount(x, "Minus");
        }
        if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
          x.cinemacharges =
            parseFloat(x.pas_charge_value) * this.calculateTaxableCharge();
        } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
          x.cinemacharges = parseFloat(x.pas_charge_value);
        }
        return x;
      });
      this.$forceUpdate();
    },
    calculatePercentageCharge: function (x) {
      let finalvalue = 1;
      // this.cinemaChargesList.map(x => {
      if (x.pas_is_percentage === "Y") {
        finalvalue += parseFloat(x.pas_charge_value) / 100;
      }
      // });
      return finalvalue;
    },
    calculateNetAmount: function (x, equation) {
      // if (equation === "Plus") {
      //   if (x.pas_is_percentage === "Y") {
      //     this.ratecard.rc_total_amount += parseFloat(x.cinemacharges);
      //   } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
      //     this.ratecard.rc_total_amount += parseFloat(x.pas_charge_value);
      //   }
      // } else if (equation === "Minus") {
      //   if (x.pas_is_percentage === "Y") {
      //     this.ratecard.rc_net_amount -= parseFloat(x.cinemacharges);
      //   } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
      //     this.ratecard.rc_net_amount -= parseFloat(x.pas_charge_value);
      //   }
      // }
      if (equation === "Plus") {
        if (x.pas_is_percentage === "Y" && x.pas_is_rebate === "N") {
          this.ratecard.rc_total_amount += parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate === "Y") {
          this.ratecard.rc_total_amount =
            this.ratecard.rc_total_amount - parseFloat(x.cinemacharges);
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_rebate == "N"
        ) {
          this.ratecard.rc_total_amount += parseFloat(x.pas_charge_value);
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_rebate == "N"
        ) {
          this.ratecard.rc_total_amount =
            this.ratecard.rc_total_amount - parseFloat(x.pas_charge_value);
        }
      } else if (equation === "Minus") {
        // console.log('x :', x);
        // console.log('this.ratecard.rc_net_amount :', this.ratecard.rc_net_amount);
        // console.log("x.ct_name :", x.ct_name);
        // console.log("x.pas_charge_value :", x.pas_charge_value);
        // console.log("x.cinemacharges :", x.cinemacharges);
        // console.log(
        //   "this.ratecard.rc_net_amount :",
        //   this.ratecard.rc_net_amount
        // );

        if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "N") {
          // console.log("if :", x.cinemacharges);
          this.ratecard.rc_net_amount -= parseFloat(x.cinemacharges);
        } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
          this.ratecard.rc_net_amount =
            this.ratecard.rc_net_amount + parseFloat(x.cinemacharges);
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_overnabove === "N" &&
          x.pas_is_rebate === "N"
        ) {
          this.ratecard.rc_net_amount -= parseFloat(x.pas_charge_value);
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_overnabove === "N" &&
          x.pas_is_rebate === "Y"
        ) {
          // console.log("else if :", x.pas_charge_value);
          this.ratecard.rc_net_amount =
            this.ratecard.rc_net_amount + parseFloat(x.pas_charge_value);
        }
      }
    },
    calculateTaxableCharge: function () {
      let finalvalue = 1;
      this.cinemaChargesList.map((x) => {
        if (x.pas_is_percentage === "Y") {
          finalvalue -= parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    ___cinemaChargesCalculation: function () {
      // this.ratecard.rc_total_amount = parseFloat(this.ratecard.rc_amount);
      // console.log("object :", this.ratecard.rc_total_amount);
      // console.log("this.ratecard.rc_amount :", this.ratecard.rc_amount);
      // console.log("this.cinemaChargesList :", this.cinemaChargesList);
      // console.log("this.ratecard.rc_is_active_inclusivtax :", this.ratecard.rc_is_active_inclusivtax);
      // this.cinemaChargesList.map(x => {
      //   if (this.ratecard.rc_is_active_inclusivtax === "N") {
      //     if (x.pas_is_percentage === "Y") {
      //       x.cinemacharges =
      //         (parseFloat(this.ratecard.rc_amount) *
      //           parseFloat(x.pas_charge_value)) /
      //         100;
      //     } else if (x.pas_is_percentage !== "Y") {
      //       x.cinemacharges = x.pas_charge_value;
      //     }
      //     // console.log("x.cinemacharges :", x.cinemacharges);
      //     this.ratecard.rc_total_amount += parseFloat(x.cinemacharges);
      //   } else if (this.ratecard.rc_is_active_inclusivtax === "Y") {
      //     if (x.pas_is_percentage === "Y") {
      //       x.cinemacharges =
      //         (parseFloat(this.ratecard.rc_amount) *
      //           parseFloat(x.pas_charge_value)) /
      //         100;
      //     } else if (x.pas_is_percentage !== "Y") {
      //       x.cinemacharges = x.pas_charge_value;
      //     }
      //     // console.log("inclusivoftax x.cinemacharges :", x.cinemacharges);
      //   }
      //   return x;
      // });
      this.$forceUpdate();
    },
    getEditRatecardList: function (rc_id) {
      CinemasService.GetRatecardById({ rc_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ratecard = {
              ...{
                cinema_id: null,
                rc_name: "",
                rc_amount: 0,
                rc_total_amount: 0,
                currency_id: null,
                rc_is_active: "Y",
                rc_is_active_inclusivtax: "Y",
                item_id: null,
                item_is_compulsory: false,
              },
              ...data.Records[0],
            };
            this.grossTotal = data.Records[0].rc_total_amount;
            this.chargeList = data.Records[0].chargesList;
            this.netTotal = data.Records[0].rc_net_amount;
            this.ratecard.item_is_compulsory =
              data.Records[0].item_is_compulsory == "Y" ? true : false;
            this.getCinemaList(data.Records[0].cinema_id);
            this.getFnBItems(data.Records[0].item_id);
            this.ratecard.currency_id = data.Records[0].curr_id;
            this.cinemaChargesList = data.Records[0].chargesList || [];
            this.cinemaChargesCalculation();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemaList: function (cinema_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "ms_cinemas"
      // });
      MasterService.GetCinemas({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            this.cinemaList.map((x) => {
              if (String(cinema_id) == String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                // this.getCinemaCharges(x.cine_id);
                console.log(" x.cine_name", x.cine_name);
                console.log(" this.selectedCinema", this.selectedCinema);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getFnBItems: function (item_id) {
      let body = {
        tableName: "fnb_items",
        item_id: item_id,
        rate_card_flag: true,
        with_prices: true,
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.fnbItems = data.Records;
              this.fnbItems.map((x) => {
                if (x.item_id == item_id) {
                  this.selectedItem = x.item_name;
                  this.selectedItemObj = x;
                }
              });
            }
            // else {
            //   this.$toasted.show(data.message);
            // }
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    OnFinalSubmit: function () {
      this.btenable = true;
      let payload = {
        id: this.ratecard.rc_id,
        ...this.ratecard,
        rc_net_amount: parseFloat(this.ratecard.rc_net_amount),
        rc_amount: parseFloat(this.ratecard.rc_amount),
        cinemaChargesList: this.cinemaChargesList,
      };
      CinemasService.UpdateRatecard(payload)
        .then((response) => {
          this.btenable = false;
          const { data } = response;
          if (data && data.status) {
            this.resetForm();
            this.$router.push({
              path: "/cinema-manager/rateCard",
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    // Saif
  },
};
</script>

<style>
.disable-edit {
  cursor: not-allowed !important;
}

.totalborder {
  border-top: 1px dotted grey;
  padding-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RatecardComponents/editRateCard.vue